export default __webpack_public_path__ + "static/media/distance-category-icon.be246b82.svg";